var React = require('react');

function DownloadDecorator (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#3d278a","height":"5","rx":"2","width":"34","x":"30.359","y":"100.299","key":0}),React.createElement("rect",{"fill":"#51e2c9","height":"5","rx":"2","transform":"matrix(.819 -.574 .574 .819 -.001 19.502)","width":"34","key":1}),React.createElement("rect",{"fill":"#04968b","height":"5","rx":"2","transform":"matrix(.819 .574 -.574 .819 2.867 182)","width":"34","key":2})]);
}

DownloadDecorator.defaultProps = {"height":"205.598","viewBox":"0 0 64.359 205.598","width":"64.359"};

module.exports = DownloadDecorator;

DownloadDecorator.default = DownloadDecorator;
